import React from "react";
import { SidenavButtonLink } from "../Sidenav/SidenavButtonLink";
import { CollapsibleButton } from "../SideBarV2/CollapsibleButton";
import { LabelText, LinkButton } from "../Sidenav/style";
import Tooltip from "@mui/material/Tooltip";
import { Palette, useTheme } from "@mui/material";
import { WorkspaceRoleEnum } from "../../generated";

type GenNavType = {
  routes: any;
  pathname: string;
  workspaceId: string;
  role: WorkspaceRoleEnum | undefined;
  collapse?: boolean;
  setCollapse?: React.Dispatch<React.SetStateAction<boolean>>;
  palette: Palette;
  isTrialExpired?: boolean;
};

// Helper function to recursively generate routes
export const genNav = ({
  routes,
  pathname,
  workspaceId,
  role,
  collapse,
  setCollapse,
  palette,
  isTrialExpired = false,
}: GenNavType) => {
  return Object.keys(routes).map((key, index) => {
    const route = routes[key];

    if(!isTrialExpired && route?.path?.includes("trial-expired"))  {
      return null
    }

    // Check if there are nested routes
    if (
      route.routes &&
      Object.keys(route.routes).length > 0 &&
      (route?.access?.includes(role) ||
        route?.access?.length === 0 ||
        route?.access === undefined)
    ) {
      return (
        <React.Fragment key={`${key}-${index}`}>
          {route.nav ? (
            <CollapsibleButton
              label={route.name}
              icon={route.icon}
              level={route.level}
              collapse={collapse}
              setCollapse={setCollapse}
              disabled={isTrialExpired}
            >
              {genNav({
                routes: route.routes,
                pathname,
                workspaceId,
                role,
                palette,
                isTrialExpired,
              })}
            </CollapsibleButton>
          ) : (
            genNav({
              routes: route.routes,
              pathname,
              workspaceId,
              role,
              palette,
              isTrialExpired,
            })
          )}
        </React.Fragment>
      );
    }

    if (
      route?.access?.includes(role) ||
      route?.access?.length === 0 ||
      route?.access === undefined
    ) {
      const currentPath = pathname.split("/")[pathname.split("/").length - 1];

      return (
        route.nav && (
          <React.Fragment key={`${key}-${index}`}>
            {route.external ? (
              <a
                href={route.path}
                target="_blank"
                className={`MuiTypography-root MuiTypography-inherit MuiLink-root MuiLink-underlineAlways`}
                rel="noreferrer"
              >
                <LinkButton startIcon={route.icon} variant="text">
                  <LabelText variant="body3">
                    <Tooltip
                      placement="bottom"
                      title={route.name}
                      componentsProps={{
                        tooltip: {
                          sx: { backgroundColor: palette.common.black },
                        },
                        arrow: { sx: { color: palette.common.black } },
                      }}
                      arrow
                    >
                      <span className="sidebutton-text cs-hidden-text">
                        {route.name}
                      </span>
                    </Tooltip>
                  </LabelText>
                </LinkButton>
              </a>
            ) : (
              <SidenavButtonLink
                active={pathname.includes(route.key)}
                to={route.path.replace(":workspaceId", workspaceId)}
                className={currentPath === route.key ? "active" : ""}
                icon={route.icon}
                label={route.name}
                collapse={collapse}
                setCollapse={setCollapse}
                disabled={!route.path.includes("/trial-expired") && isTrialExpired}
              />
            )}
          </React.Fragment>
        )
      );
    } else return null;
  });

  // Base case: no nested routes
};
